module.exports = {
  "country": "UA",
  "artist": "Tvochi",
  "song": "Heart of Steel",
  "year": "2023",
  "place": "6",
  "spotify": "2qfUbfm7Wf2GgD1AI2gtPs"
};